import { FILE_BASE_URL } from "@/config";
import md5 from "js-md5";
import { Loading } from "element-ui";
/**
 * 文件操作相关辅助函数
 */

/**
 * 拼接完整的图片地址
 * @param path 文件路径，如 upload/xxx.png
 */
export function getUploadedFileUrl(path: string) {
  return `${FILE_BASE_URL}/${path}`;
}

// 生成上传文件路径地址
export function getUploadPath(
  fileName: string,
  result: string | ArrayBuffer | null
) {
  return `upload/images/${md5.hex(result || "")}.${getFileSuffix(fileName)}`;
}

// 获取文件后缀
export function getFileSuffix(filename: string) {
  const index = filename.lastIndexOf(".");
  const suffix = filename.substring(index + 1);
  return suffix.toLowerCase();
}

/**
 * 通过文件路径下载文件二进制信息
 * */
export function getFileBlobByUrl(
  url: string,
  progress?: (progress: number | string) => void
): Promise<Blob> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("get", url, true);
    // 至关重要
    xhr.responseType = "blob";
    xhr.onprogress = function (event) {
      progress && progress((event.loaded / event.total).toFixed(2));
    };

    xhr.onload = function () {
      if (this.status === 200) {
        // 得到一个blob对象
        const blob = this.response;
        resolve(blob);
      } else {
        reject(new Error("获取文件失败"));
      }
    };

    xhr.onerror = function () {
      reject(new Error("获取文件失败"));
    };

    xhr.send();
  });
}

/**
 * 通过二进制流下载文件
 * @param {*} blobData blob 二进制流
 */
export function downloadByBlob(blobData: Blob, fileName?: string): void {
  const url = window.URL.createObjectURL(blobData);
  const link = document.createElement("a");
  link.style.display = "none";
  link.href = url;
  link.setAttribute("download", fileName || "");
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

/**
 * 通过文件地址下载文件
 */
export function downloadByUrl(url: string, fileName: string) {
  const loadingInstance = Loading.service({
    fullscreen: true,
    text: "文件下载中，请稍候...",
  });
  return getFileBlobByUrl(url).then((blob) => {
    downloadByBlob(blob, fileName);
    loadingInstance.close();
  });
}

// 验证是否为blob格式
export function blobValidate(data: any) {
  return data.type !== "application/json";
}
